const fetch = async (url, options = {}) => {
    const headers = options.headers || {};

    if ((options.data || options.body) && !url.includes('kanvas')) {
        headers['content-type'] = 'application/json';
    }
    options.headers = headers;
    options.credentials = 'same-origin';
    const makeRequest = async () => {
        const response = await window.fetch(url, options);
        return response;
    };
    const response = await makeRequest();
    let json;
    if (headers.accept === 'text/csv') {
        json = await response.text();
    } else if (headers.accept === 'application/xml') {
        json = response.text();
    } else if (headers.accept === 'file/xml') {
        json = await response.blob();
        // } else if ((response.type === 'cors' || response.status === 204) && !url.includes('kanvas')) {
        //     json = response;
    } else {
        json = await response.json();
    }
    return json;
};

export default fetch;
